import { render, staticRenderFns } from "./BB-embed.vue?vue&type=template&id=ed86dbc8&"
import script from "./BB-embed.vue?vue&type=script&lang=js&"
export * from "./BB-embed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports